import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  color?: string;
}

export const Wrapper = styled.div``;

export const Label = styled.p`
  color: ${COLORS.BLACK};
  font-family: ${FONTS.OPEN_SANS};
  margin-bottom: 10px;
  font-size: 12px;
  
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-weight: 600;
    font-size: 14px;
  }
`;

export const ActionProfile = styled.div`
  display: flex;
  margin-bottom: 26px;
  label:last-child {
    margin-left: 22px;
  }
`;

export const TicketWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    grid-template-columns: 1fr 1fr;

    & > div:nth-child(2) {
      margin-left: 15px;
    }
    & > div:nth-child(4) {
      margin-left: 15px;
    }
  }
`;

export const BillWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    grid-template-columns: 1fr 1fr;

    & > div.rznSocial {
      margin-left: 15px;
      grid-column-start: 2;
    }
    & > div.district {
      grid-column-start: 1;
    }
    & > div.address {
      margin-left: 15px;
    }
  }
`;

export const CentralHelp = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 12px;
  color: ${COLORS.GRAY_TEXT};
  margin: -30px 0 30px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const LinkHelp = styled.a`
  color: ${(props: Props) => props.color};
  font-size: 14px;
`;

export const FieldWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    grid-template-columns: 1fr 1fr;
    & > div:nth-child(2n) {
      margin-left: 15px;
    }
  }
`;

export const IconInfo = styled.span`
  margin: 0 auto 0 4px;
  cursor: pointer;
`;

export const ModalContent = styled.p`
  width: 250px;
  margin: 50px 30px 30px;
  font-family: ${FONTS.OPEN_SANS};
`;